/** UCAT's four subtests, in the order of a sitting and of a set's positions. */
export const UCAT_SUBTEST_KEYS = [
  'verbal_reasoning',
  'decision_making',
  'quantitative_reasoning',
  'situational_judgement',
];

export const UCAT_SUBTEST_LABELS = {
  verbal_reasoning: 'Verbal Reasoning',
  decision_making: 'Decision Making',
  quantitative_reasoning: 'Quantitative Reasoning',
  situational_judgement: 'Situational Judgement',
};
